import triggerTracking from '@blueprint/tracking';
import { TRACKING_EVENT, TRACKING_CATEGORY } from 'listing-details/constants';

export const trackBackToSearchClick = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'clickthrough',
        eventLabel: 'back to search link'
    });
};

export const trackSimilarListingClick = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'clickthrough',
        eventLabel: 'similar properties link'
    });
};
